import { ComplexValue } from 'app/types-shared';
import { FilterCommonTypes } from '../types-store';
import { CustomFilterType, FilterCommonValues } from './types';

const serializeCustomText = (value: FilterCommonValues<string>[]) => value && value[0]?.value?.trim() || undefined;
const serializeCustomCheckbox = (value: FilterCommonValues<ComplexValue<number>>) => !!(value && value[0]?.value);

const customFieldSerialization = {
  [CustomFilterType.text]: serializeCustomText,
  [CustomFilterType.checkbox]: serializeCustomCheckbox
};

export const getCustomValue = (
  value: FilterCommonValues<FilterCommonTypes>[],
  type: CustomFilterType
) => {

  const serialization = customFieldSerialization[type];
  return serialization
    ? serialization(value)
    : value;
};
